export const NOTE_SECTIONS = {
    complaint: 'Chief complaint',
    doctor: "Doctor's note",
    triage: 'Triage note',
    pharmacy: 'Pharmacy note',
    general: 'Observation',
} as const;
export type NoteSection = keyof typeof NOTE_SECTIONS;
export interface NoteContext {
    encounter: string | null;
    section: NoteSection;
    resource: string | null;
    replyTo: string | null;
}
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const PREFIX = '[Pamosi clinical note v1] ';
export function encodeClinicalNote(context: NoteContext, text: string): string {
    return PREFIX + JSON.stringify(context) + '\n' + text.trim();
}
export function decodeClinicalNote(body: string): (NoteContext & { text: string }) | null {
    if (!body.startsWith(PREFIX)) return null;
    const end = body.indexOf('\n');
    if (end < 0) return null;
    try {
        const c = JSON.parse(body.slice(PREFIX.length, end)) as NoteContext;
        if (!Object.prototype.hasOwnProperty.call(NOTE_SECTIONS, c.section)) return null;
        for (const id of [c.encounter, c.resource, c.replyTo]) {
            if (id !== null && (typeof id !== 'string' || !UUID.test(id))) return null;
        }
        return { ...c, text: body.slice(end + 1) };
    } catch { return null; }
}

export function noteMatches(note: NoteContext, scope: { encounterId?: string | undefined; section?: NoteSection | undefined; resourceId?: string | undefined }): boolean {
    return (!scope.encounterId || note.encounter === scope.encounterId)
        && (!scope.section || note.section === scope.section)
        && (!scope.resourceId || note.resource === scope.resourceId);
}
